import { RecipientListModel } from "./RecipientList.model";

export class RecipientList extends RecipientListModel {
    // Add custom methods here
}
